import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
:root,
:host {
  --size-base-unit: 0.5rem;
}

/**
 * RTL support for values logical properties can't automatically adjust for
 * 1) Percentage based horizontal translate values need to be flipped
 * 2) Background gradients using "to right" or "to left" need to be switched to using deg values
 * 3) Background Position From is used for reversing animation from right to left at 0%
 * 4) Background Position To is used for reversing animation from right to left at 100%
 * 5) Rotate Icon to 180deg for nav button
 * 6) Transformation size for badge left positions
 * 7) Transformation size for badge right positions
 * 8 to 18) Padding values for Input Field Type Tel
 */
[dir=rtl] {
  --rtlTranslateX: 50%; /* 1 */
  --rtlGradientToRight: 270deg; /* 2 */
  --rtlBackgroundPositionFrom: -135%; /* 3 */
  --rtlBackgroundPositionTo: 0%; /* 4 */
  --rtlRotate180: 180deg; /* 5 */
  --rtlRotate135: 135deg;
  --rtlBadgeLeft: -1.5; /* 6 */
  --rtlBadgeRight: 1.5; /* 7 */
  --rtlTelTypeInputFieldPaddingStart: calc(var(--size-base-unit) * 5); /* 8 */
  --rtlTelTypeInputFieldPaddingEnd: calc(var(--size-base-unit) * 2); /* 9 */
  --rtlTelTypeInputFieldMedPaddingStart: calc(var(--size-base-unit) * 4.5); /* 10 */
  --rtlTelTypeInputFieldMedPaddingEnd: calc(var(--size-base-unit) * 1.5); /* 11 */
  --rtlTelTypeInputFieldSmPaddingStart: calc(var(--size-base-unit) * 4); /* 12 */
  --rtlTelTypeInputFieldSmPaddingEnd: calc(var(--size-base-unit) * 1); /* 13 */
  --rtlTelTypeInputFieldCharBeforePaddingEnd: calc(var(--size-base-unit) * 3.75); /* 14 */
  --rtlTelTypeInputFieldCharAfterPaddingStart: calc(var(--size-base-unit) * 6); /* 15 */
  --rtlTelTypeInputFieldCharAfterErrPaddingStart: calc(var(--size-base-unit) * 9); /* 16 */
  --rtlTelTypeInputFieldIconAfterErrPaddingStart: calc(var(--size-base-unit) * 8); /* 17 */
  --rtlTelTypeInputFieldIconCharAfterErrPaddingStart: calc(var(--size-base-unit) * 12); /* 18 */
  --rtlDisplayNone: none;
  --rtlDisplayBlock: block;
  --rtlDrawerRightTranslateX: -100%;
  --rtlDrawerLeftTranslateX: 100%;
}

/**
 * Visible focus outline for elements on a light background
 */
/**
 * Visible focus outline for elements on a dark background
 */
/**
 * Invisible focus outline for elements that need a more visible
 * focus state for high-contrast mode
 */
/**
 * Visually hidden from display
 */
/**
 * style for text ellipsis
 */
/**
 * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
 */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */ /* ------------------------------------*\
    #ACCORDION-PANEL
\*------------------------------------ */
:host {
  display: block;
}

.cat-c-accordion-panel.cat-is-disabled {
  color: var(--cat-theme-color-content-disabled);
  cursor: not-allowed;
}

/**
* Accordion panel button
* 1) Icon rotating on open was causing scrollbars to continuously appear/disapear
*    during the animation, overflow-inline: hidden; prevents this from happening
*/
.cat-c-accordion-panel__button {
  display: flex;
  align-items: center;
  appearance: none;
  background: none;
  border: none;
  padding: calc(var(--size-base-unit) * 1.875) calc(var(--size-base-unit) * 2);
  width: 100%;
  cursor: pointer;
  color: inherit;
  position: relative;
  overflow-x: hidden; /* 1 */
  transition: background-color var(--cat-anim-fade-quick) var(--cat-anim-ease);
  /**
   * Accordion panel button large
   */
}
.cat-c-accordion-panel__button:hover:not(:disabled) {
  background-color: var(--cat-accordion-panel-hover-background, var(--cat-theme-color-background-subtle));
  border-color: var(--cat-theme-color-border-default-hover);
}
.cat-c-accordion-panel__button:focus:not(:focus-visible) {
  outline: none;
}
.cat-c-accordion-panel__button:focus-visible {
  outline: none;
  border-block-start: var(--cat-border-width-sm) solid var(--cat-theme-color-focus-ring);
  border-block-end: var(--cat-border-width-sm) solid var(--cat-theme-color-focus-ring);
  color: var(--cat-theme-color-content-strong);
}
.cat-c-accordion-panel__button:disabled {
  color: var(--cat-theme-color-content-disabled);
  pointer-events: none;
  border-block-end-color: var(--cat-theme-color-border-disabled);
  border-block-start-color: var(--cat-theme-color-border-disabled);
}
.cat-c-accordion-panel--large .cat-c-accordion-panel__button {
  padding: calc(var(--size-base-unit) * 1.875) calc(var(--size-base-unit) * 2);
}
.cat-c-accordion-panel--toggle-right .cat-c-accordion-panel__button {
  justify-content: space-between;
}

/**
 * Accordion icon
 */
.cat-c-accordion-panel__icon {
  transition: transform var(--cat-anim-fade-quick) var(--cat-anim-ease);
  margin-inline-end: calc(var(--size-base-unit) * 2);
  --cat-icon-width: calc(var(--size-base-unit) * 2);
  --cat-icon-height: calc(var(--size-base-unit) * 2);
  /**
   * Right aligned accordion icon
   */
  /**
   * Accordion icon animation
   */
}
.cat-c-accordion-panel--toggle-right .cat-c-accordion-panel__icon {
  margin-inline: calc(var(--size-base-unit) * 2) 0;
}
.cat-c-accordion-panel.cat-is-active .cat-c-accordion-panel__icon {
  transform: rotate(-180deg);
}

/**
 * Slot before
 */
slot[name=before] {
  display: block;
  margin-inline-end: calc(var(--size-base-unit) * 2);
}

/**
 * Slot after
 */
slot[name=after] {
  display: block;
  margin-inline-start: calc(var(--size-base-unit) * 2);
}

/**
 * Accordion panel header
 */
.cat-c-accordion-header {
  margin-inline-end: auto;
  font-family: var(--cat-theme-typography-body-font-family);
  font-weight: var(--cat-theme-typography-body-font-weight);
  font-size: var(--cat-theme-typography-body-font-size);
  line-height: var(--cat-theme-typography-body-line-height);
  text-align: start;
  word-break: break-word;
  hyphens: auto;
  /**
   * Accordion panel header large
   */
}
.cat-c-accordion-panel--large .cat-c-accordion-header {
  font-family: var(--cat-theme-typography-title-font-family);
  font-weight: var(--cat-theme-typography-title-font-weight);
  font-size: var(--cat-theme-typography-title-font-size);
  line-height: var(--cat-theme-typography-title-line-height);
}
@media all and (width <= calc(48rem - 0.02px)) {
  .cat-c-accordion-panel--large .cat-c-accordion-header {
    font-size: var(--cat-theme-typography-title-mobile-font-size);
    line-height: var(--cat-theme-typography-title-mobile-line-height);
  }
}

/**
 * Accordion panel body
 * 1) Visibility set to hidden so user can't tab inside panel content while closed
 */
.cat-c-accordion-panel__body {
  margin: 0;
  overflow: auto;
  visibility: hidden; /* 1 */
  transition: height var(--cat-anim-fade-quick) var(--cat-anim-ease), visibility var(--cat-anim-fade-quick) var(--cat-anim-ease);
  /**
   * Accordion panel body within active accordion panel
   * 1) Visibility set to visible so user can tab within panel content when panel is open
   */
  /**
   * Allow scrolling if a panel height is present
   */
}
.cat-c-accordion-panel.cat-is-active .cat-c-accordion-panel__body {
  visibility: visible;
}
.cat-c-accordion-panel.cat-c-accordion-panel--has-panel-height.cat-is-active .cat-c-accordion-panel__body {
  overflow: auto;
}

/**
 * Accordion panel body inner
 * Display should be none so that It will avoid overflow when it is not active
 */
.cat-c-accordion-panel__body-inner {
  padding: calc(var(--size-base-unit) * 2);
  padding-inline-start: calc(var(--size-base-unit) * 6);
  padding-block-start: calc(var(--size-base-unit) * 0.25);
  display: none;
  /**
    Align body with the header content when we use arrow icon on right
  */
  /**
   * Accordion panel body within active accordion panel
   * 1) Display set to block so user can tab within panel content when panel is open
   */
}
.cat-c-accordion-panel--toggle-right .cat-c-accordion-panel__body-inner {
  padding: calc(var(--size-base-unit) * 2);
  padding-block-start: calc(var(--size-base-unit) * 0.25);
}
.cat-c-accordion-panel.cat-is-active .cat-c-accordion-panel__body-inner {
  display: block;
}
`;
       